import { useEventNameMatch } from '@shared/components/AuthProvider/AuthProvider.utils';
import { get } from 'lodash-es';
import { useEventWebsiteGuestQuery } from '../../../../GuestSite.graphql.generated';
import { EventDesignPurpose } from '@graphql/generated-base';
import { useMemo } from 'react';
import { deriveWebsiteColorsFromEventDesign } from '@shared/utils/websiteDesign';

export const useDialogThemeController = () => {
  const nameMatchResult = useEventNameMatch();
  const eventHandle = get(nameMatchResult, 'eventName', '');
  const { data: event, loading } = useEventWebsiteGuestQuery({
    variables: { eventHandle, eventDesignPurpose: EventDesignPurpose.live },
    batchMode: 'fast',
    ssr: false,
  });
  const eventDesign = event?.eventByName?.eventDesign;

  const colors = useMemo(() => {
    if (!eventDesign) return undefined;
    return deriveWebsiteColorsFromEventDesign(eventDesign, eventDesign.theme);
  }, [eventDesign]);

  return {
    pageColor: colors?.pageColor,
    pageFontColor: colors?.pageFontColor,
    isThemeReady: !loading && event !== undefined,
  };
};
